(function ($, document, window) {
    'use strict';

    $(function () {
        const $card = $('.js-float-card');

        if (!$card.length) {
            return;
        }

        const $cardParent = $card.parent();
        const $block = $('.js-content-sidebar');

        const contentSidebarBreakpoint = getComputedStyle(document.documentElement).getPropertyValue('--content-sidebar-breakpoint').trim();
        const contentSidebarSpacerRem = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--content-sidebar-spacer'));
        const contentSidebarSpacer = contentSidebarSpacerRem * parseFloat(getComputedStyle(document.documentElement).fontSize);

        const stickyHeaderHeightRem = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height'));
        const stickyHeaderHeight = stickyHeaderHeightRem * parseFloat(getComputedStyle(document.documentElement).fontSize);

        var matchMedia = window.matchMedia(`(min-width: ${contentSidebarBreakpoint})`);
        var fixedClass = 'is-fixed';
        var absoluteClass = 'is-absolute';

        let ticking = false;
        let resizeTimeout;

        /**
         * Handles changes to the matchMedia query.
         * Resets the card when viewport width is below the breakpoint.
         * 
         * @param {MediaQueryListEvent|MediaQueryList} e - The matchMedia event or initial state
         */
        function handleMatchMedia(e) {
            if (!e.matches) resetCard();
            else handleCardState();
        }

        /**
         * Determines whether or not the float card can be fixed.
         * 
         * @returns {boolean} True if float card can be fixed, false otherwise.
         */
        function canCardBeFixed() {
            if (!matchMedia.matches) return false;

            const adminBarHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--wp-admin--admin-bar--height')) || 0;
            const cardHeight = $card.outerHeight();
            const availableHeight = window.innerHeight - adminBarHeight - contentSidebarSpacer - stickyHeaderHeight;

            return cardHeight < availableHeight;
        }

        /**
         * Resets the card to its natural position.
         */
        function resetCard() {
            $card.removeClass([fixedClass, absoluteClass]).css({
                '--inset-block-start': '',
                '--transform': '',
            });
        }

        /**
         * Fixes the card in its full state.
         * 
         * @param {number} cardLeft - The left position of the card. Calculated based on the parent width and card width.
         */
        function setFixedCard(cardLeft) {
            $card.removeClass(absoluteClass).addClass(fixedClass).css({
                '--inset-block-start': `${contentSidebarSpacer + stickyHeaderHeight}px`,
                '--transform': `translateX(${cardLeft}px)`,
            });
        }

        /**
         * Sets the card to absolute positioning at the bottom of the container.
         * 
         * @param {number} topPosition - Position from top for absolute positioning.
         * @param {number} cardLeft - The left position of the card. Calculated based on the parent width and card width.
         */
        function setAbsoluteCard(topPosition, cardLeft) {
            $card.removeClass(fixedClass).addClass(absoluteClass).css({
                '--inset-block-start': `${topPosition}px`,
                '--transform': `translateX(${cardLeft}px)`,
            });
        }

        /**
         * Updates the card's position and state based on scroll position and viewport size.
         */
        function handleCardState() {
            if (!matchMedia.matches) return;

            if (!canCardBeFixed()) {
                resetCard();
                return;
            }

            const parentWidth = $cardParent.width();
            const cardWidth = $card.width();
            const cardHeight = $card.outerHeight();
            const cardLeft = parentWidth - cardWidth - 2;
            const parentOffset = $cardParent.offset().top;
            const scrollTop = $(window).scrollTop();

            // Calculate the point where the card should become absolute.
            const blockBottom = $block.offset().top + $block.outerHeight();
            const stopPoint = blockBottom - cardHeight;
            const fixedOffset = scrollTop + contentSidebarSpacer + stickyHeaderHeight;

            // If we haven't scrolled to the trigger point yet, keep card in natural position.
            if (scrollTop < parentOffset - contentSidebarSpacer - stickyHeaderHeight) {
                resetCard();
                return;
            }

            // If we've scrolled to the bottom boundary, set card to absolute position.
            if (fixedOffset >= stopPoint) {
                const absoluteTop = stopPoint - parentOffset;
                setAbsoluteCard(absoluteTop, cardLeft);
                return;
            }

            setFixedCard(cardLeft);
        }

        function onScroll() {
            if (!ticking) {
                requestAnimationFrame(() => {
                    handleCardState();
                    ticking = false;
                });
                ticking = true;
            }
        }

        function onResize() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(handleCardState, 100);
        }

        matchMedia.addEventListener('change', handleMatchMedia);
        handleMatchMedia(matchMedia);

        $(window).on('scroll', onScroll);
        $(window).on('resize', onResize);

        handleCardState();
    });
})(jQuery, document, window);